// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AideVideo_container__3rdPh {\n  display: flex;\n  padding: 1rem;\n  justify-content: center;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Aide/AideVideo.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB","sourcesContent":[".container {\n  display: flex;\n  padding: 1rem;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "AideVideo_container__3rdPh"
};
export default ___CSS_LOADER_EXPORT___;
